var map = {
	"./logo_1.png": "lUua",
	"./logo_1副本.png": "uNL6",
	"./logo_2 - 副本.png": "OOUz",
	"./logo_2.png": "Z9TY",
	"./logo_3 - 副本 (2).png": "h4hz",
	"./logo_3 - 副本.png": "X+G+",
	"./logo_3.png": "+iNW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8xO/";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/logo_.*\.png$
// module id = 8xO/
// module chunks = 0